<template>
  <div class="quotaBlock" :style="{paddingTop: option.attribute.paddingTop+'px',paddingRight: option.attribute.paddingRight+'px',
    paddingBottom:option.attribute.paddingBottom+'px',paddingLeft:option.attribute.paddingLeft+'px'}">
    <div style="color: #fff;font-size: 20px;text-indent: 10px;">机房详情</div>
    <div style="color: #ccc;height: 30px;font-size: 16px;margin-top: 16px;">
      <div style="float: left;width: 50%;line-height: 20px">线路连接状态</div>
      <div style="float: right;width: 50%;text-align: center;">
        <img :src="fileUrl+stateImg[cptData.lineState]" style="height: 22px;"/>
      </div>
    </div>
    <div style="color: #ccc;height: 30px;font-size: 16px;margin-top: 6px;">
      <div style="float: left;width: 50%;line-height: 20px">设备监控状态</div>
      <div style="float: right;width: 50%;text-align: center;">
        <img :src="fileUrl+stateImg[cptData.devState]" style="height: 22px;"/>
      </div>
    </div>
    <div style="color: #ccc;height: 30px;font-size: 16px;margin-top: 6px;">
      <div style="float: left;width: 50%;line-height: 20px">网络流量</div>
      <div style="float: right;width: 50%;text-align: center">{{cptData.flow}}Mbps</div>
    </div>
    <div style="color: #ccc;height: 30px;font-size: 16px;margin-top: 6px;">
      <div style="float: left;width: 50%;line-height: 20px">设备数量</div>
      <div style="float: right;width: 50%;text-align: center">{{cptData.deviceNum}}台</div>
    </div>
  </div>
</template>

<script>
import {getDataJson, pollingRefresh} from "@/utils/refresh-cpt-data";
import {fileUrl} from '/env'
export default {
  name: "cpt-img-quota-tips",
  props:{
    width:Number,
    height:Number,
    option:Object,
    current: Object
  },
  data(){
    return {
      fileUrl,
      uuid:'',
      cptData:[],
      stateImg:['/imgPool/20220314143525yichang.svg','/imgPool/20220314143541health.svg'],
    }
  },
  computed: {
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    const attr = this.option.attribute
    if (!attr.globalDataReload) attr.globalDataReload = [0]

    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods:{
    refreshCptData(cptDataForm = this.option.cptDataForm){
      pollingRefresh(this.uuid, cptDataForm, ()=>this.loadData(cptDataForm))
    },
    loadData(cptDataForm){
      getDataJson(cptDataForm,'',(res)=> {
                this.cptData = res;
            })
    },
  }
}
</script>

<style scoped>
.quotaBlock{width:100%;height:100%;background-size: 100% 100%;box-sizing: border-box}
</style>
